/** The project the current screen is about: the tab's (`/p/$id…`) or Home's `?project=` filter. */
import { useRouterState } from '@tanstack/react-router'
import { projectOfPath } from '../../lib/ia.js'

export function useRouteProject(): string | undefined {
  return useRouterState({
    select: (s) => {
      const fromPath = projectOfPath(s.location.pathname)
      if (fromPath) return fromPath
      const q = (s.location.search as { project?: unknown }).project
      return typeof q === 'string' && q ? q : undefined
    },
  })
}

/** Which top-level place is current: a project id, `home`, or `settings` (else undefined). */
export function useCurrentPlace(): string | undefined {
  return useRouterState({
    select: (s) => {
      const p = s.location.pathname
      if (p === '/home' || p.startsWith('/home/')) return 'home'
      if (p === '/settings' || p.startsWith('/settings/')) return 'settings'
      if (p === '/tree') return 'tree'
      return projectOfPath(p)
    },
  })
}
